import React from 'react';
import { Tabs } from '@mui/material';

const DSTabs = (props: React.ComponentProps<typeof Tabs>) => {
  return <Tabs {...props} />;
};

export default DSTabs;
